// Libs
import React from 'react';
// Components
import OrdersOverview from '../OrdersOverview/OrdersOverview';

const OrdersTotal = props => (
	<OrdersOverview {...props} orderFlowType='orders_total' />
);
export default OrdersTotal;
